import { createApi } from "@reduxjs/toolkit/query/react";
import { createServiceBaseQuery } from "../../../../../store/client/serviceBaseQuery";

export interface ToSQLResponse {
  sql: string;
}

export interface ToDerivedMetricSQLResponse {
  derived_metric: string;
}

export interface ExplainSQLResponse {
  detailed_explanation: string;
  simple_explanation: string;
  is_error: boolean;
}

export const hermesService = createApi({
  reducerPath: "hermes",
  baseQuery: createServiceBaseQuery("hermesUri"),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    toSQL: builder.mutation<ToSQLResponse, { query: string }>({
      query: (data) => ({
        url: `/api/to_sql`,
        method: "POST",
        body: { query: data.query },
      }),
    }),
    toDerivedMetricSQL: builder.query<
      ToDerivedMetricSQLResponse,
      { query: string; datasetName: string }
    >({
      query: (data) => ({
        url: `/api/to_derived_metric_sql`,
        method: "POST",
        body: { query: data.query, dataset_name: data.datasetName },
      }),
    }),
    explainSQL: builder.query<ExplainSQLResponse, { sql: string }>({
      query: (data) => ({
        url: `/api/explain`,
        method: "POST",
        body: { query: data.sql },
      }),
    }),
  }),
});

export const { useToSQLMutation, useLazyExplainSQLQuery } = hermesService;
